// removed by extract-text-webpack-plugin
module.exports = {"inline":"styles__inline___3lKAX","dot":"styles__dot___3J2mU","bookingLoaderFade":"styles__bookingLoaderFade___PiOu1","second":"styles__second___1CMkl","third":"styles__third___3HPpY"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/dotLoader/styles.css
// module id = SUMG
// module chunks = 2